import EditProfileForm from './Dashboard/Pages/UserProfile/EditProfileForm';
import UserCard from './Dashboard/Pages/UserProfile/UserCard';
import ViewAddressModal from './ViewAddressModal';

export { EditProfileForm, UserCard, ViewAddressModal };
